import { Controller } from '@hotwired/stimulus'
import Timeline from '../lib/Timeline.js'
import moment from 'moment'

export default class extends Controller {
  static values = {
    items: Array,
    groups: Array,
    startDate: String,
    endDate: String,
  }

  static targets = ['expandCollapseIcon']

  async connect() {
    this.timeline = new Timeline(
      this.element,
      this.itemsValue,
      this.groupsValue,
      this.startDateValue,
      this.endDateValue,
    )
  }

  disconnect() {
    this.timeline?.disconnect?.()
  }

  visTimeline() { return this.timeline.timeline }

  collapseExpand() {
    const timeline = this.timeline
    const itemSet = timeline.timeline.itemSet

    if (this.expandCollapseIconTarget.textContent === 'collapse_all') {
      this.expandCollapseIconTarget.textContent = 'expand_all'
      timeline.groups.forEach(group => {
        if (group.showNested) {
          itemSet.toggleGroupShowNested(itemSet.groups[group.id])
        }
      })
    } else {
      timeline.groups.forEach(group => {
        this.expandCollapseIconTarget.textContent = 'collapse_all'
        if (!group.showNested) {
          itemSet.toggleGroupShowNested(itemSet.groups[group.id])
        }
      })
    }
  }

  resetWindow() {
    const currentWindow = this.visTimeline().getWindow()

    const newWindow = {
      start: moment().subtract(2, 'months'),
      end: moment().subtract(1, 'month').add(moment(currentWindow.end).subtract(moment(currentWindow.start)))
    }

    this.visTimeline().setWindow(newWindow.start, newWindow.end, { animation: true })
  }
}
